import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';

// URL-bar canonicalization: strip trailing slashes so indexed `/x/` URLs
// land on `/x` (replaces the strict-slash entries of redirectUrlMap, which
// router matching cannot express). Rendering is unaffected either way.
export default function TrailingSlashRedirect() {
  const {pathname, search, hash} = useLocation();
  if (pathname !== '/' && pathname.endsWith('/')) {
    return (
      <Navigate to={pathname.replace(/\/+$/, '') + search + hash} replace />
    );
  }
  return null;
}
